// Admin Cost dashboard — how much each user costs us in OpenAI spend, split
// voice vs chat, plus the editable rate card the costs are computed from.
// Two tabs: "Spend" (KPIs + per-user table + drill-down) and "Model pricing".
// Source: core-lambda admin_module/reporting/cost_controller.py.

import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs";
import { WindowToggle } from "../../../Components/admin/reporting/primitives";
import {
  CustomRangePopover,
  DashboardSurface,
  Toolbar,
} from "../../../Components/admin/reporting/controls";
import CostSpendTab from "./CostSpendTab";
import PricingTab from "./PricingTab";

const AdminCost = () => {
  const [tab, setTab] = useState("spend");
  const [windowDays, setWindowDays] = useState(30);
  const [range, setRange] = useState(null); // {start,end} custom | null

  return (
    <DashboardSurface>
      <div className="space-y-7">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-xl font-semibold tracking-tight">LLM cost</h1>
            <p className="text-sm text-muted-foreground">
              OpenAI spend per user — voice &amp; chat — and the model rate card.
            </p>
          </div>
          {tab === "spend" ? (
            <WindowToggle
              value={range ? null : windowDays}
              onChange={(d) => {
                setRange(null);
                setWindowDays(d);
              }}
            />
          ) : null}
        </div>

        <Tabs value={tab} onValueChange={setTab} className="space-y-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <TabsList>
              <TabsTrigger value="spend">Spend</TabsTrigger>
              <TabsTrigger value="pricing">Model pricing</TabsTrigger>
            </TabsList>
            {tab === "spend" ? (
              <Toolbar className="ml-auto">
                <div className="flex items-center gap-1.5">
                  <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                    Range
                  </span>
                  <CustomRangePopover
                    active={range}
                    onApply={(r) => setRange(r)}
                    onClear={() => setRange(null)}
                  />
                </div>
              </Toolbar>
            ) : null}
          </div>

          <TabsContent value="spend" className="mt-0">
            <CostSpendTab windowDays={windowDays} range={range} />
          </TabsContent>
          <TabsContent value="pricing" className="mt-0">
            <PricingTab />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardSurface>
  );
};

export default AdminCost;
